import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '娱乐新闻', to: '/news' },
  { label: '影视推荐', to: '/movies' },
  { label: '热门话题', to: '/hot-topics' },
  { label: '关于我们', to: '/about' },
];

export default function Header() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    if (q) navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap text-[15px] transition-colors ${
      isActive ? 'text-primary-600 font-semibold' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex items-center gap-2 md:gap-3" aria-label="靠逼 首页">
          <span className="font-logo text-3xl leading-none text-primary-600 md:text-4xl">靠逼</span>
          <span className="hidden flex-col leading-tight sm:flex">
            <span className="text-base font-bold tracking-wide text-foreground-950">靠逼</span>
            <span className="text-[11px] tracking-[0.2em] text-foreground-500">娱乐资讯</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-[26px] left-0 h-[3px] w-full rounded-full bg-primary-500" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden lg:flex">
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2 transition-colors focus-within:border-primary-400">
            <i className="ri-search-line text-[15px] text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索资讯 / 影视 / 话题"
              className="w-40 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-56"
            />
          </div>
          <button
            type="submit"
            className="ml-2 hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 lg:block"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
          aria-label="打开菜单"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="animate-slideDown border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯 / 影视 / 话题"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-[15px] ${
                    isActive
                      ? 'bg-primary-50 font-semibold text-primary-600'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}